import request from '@/utils/requests.js'

// Login function
export async function login(data) {
    return request({
        url: '/auth/login',
        method: 'post',
        data: {
            username: data.email, // Backend expects 'username' field
            password: data.password
        }
    })
}

// Get user info function
export async function getUserInfo() {
    return request({
        url: '/auth/user-info',
        method: 'get'
    })
}

// Check token function
export async function checkToken() {
    return request({
        url: '/auth/check-token',
        method: 'get'
    })
}

// Logout function (client-side only)
export function logout() {
    localStorage.removeItem('user')
    return Promise.resolve()
}

// Get current user profile
export async function getProfile() {
    return request({
        url: '/auth/profile',
        method: 'get'
    })
}

// Change password
export async function changePassword(data) {
    return request({
        url: '/auth/change-password',
        method: 'post',
        data: data
    })
}

export const authService = {
    async login(email, password) {
        try {
            const response = await login({ email, password })
            
            if (response.data && response.data.access_token) {
                const userData = {
                    access_token: response.data.access_token,
                    token_type: response.data.token_type,
                    email: email
                }
                
                // Store user data in localStorage
                localStorage.setItem('user', JSON.stringify(userData))
                
                // Also fetch and store user info
                try {
                    const userInfoResponse = await this.getUserInfo()
                    if (userInfoResponse) {
                        // Ensure role is lowercase for compatibility
                        const userInfo = {
                            ...userInfoResponse,
                            role: userInfoResponse.role ? userInfoResponse.role.toLowerCase() : 'patient'
                        }
                        localStorage.setItem('userInfo', JSON.stringify(userInfo))
                        
                        // Update user object with role for immediate use
                        userData.role = userInfo.role
                        userData.id = userInfo.id
                        userData.name = userInfo.name
                        localStorage.setItem('user', JSON.stringify(userData))
                    }
                } catch (userInfoError) {
                    console.warn('Could not fetch user info:', userInfoError)
                }
                
                return userData
            } else {
                throw new Error('Resposta inválida do servidor')
            }
        } catch (error) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail)
            } else if (error.response?.status === 401) {
                throw new Error('Email ou senha incorretos')
            } else if (error.response?.status >= 500) {
                throw new Error('Erro interno do servidor')
            } else {
                throw new Error('Erro ao fazer login. Tente novamente.')
            }
        }
    },

    async getUserInfo() {
        try {
            const response = await getUserInfo()
            return response.data
        } catch (error) {
            throw new Error('Erro ao obter informações do usuário')
        }
    },

    async checkToken() {
        try {
            const response = await checkToken()
            return response.data
        } catch (error) {
            return { valid: false }
        }
    },

    logout() {
        return logout()
    },

    async getProfile() {
        try {
            const response = await getProfile()
            return response.data
        } catch (error) {
            throw new Error('Erro ao obter informações do perfil')
        }
    },

    async changePassword(data) {
        try {
            const response = await changePassword(data)
            return response.data
        } catch (error) {
            if (error.response?.data?.detail) {
                throw error
            } else if (error.response?.status === 400) {
                throw new Error('Dados inválidos para alteração de senha')
            } else {
                throw new Error('Erro ao alterar senha')
            }
        }
    }
}

export default authService
